import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLayouts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('email-layouts', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLayout(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`email-layouts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
